/**
 * API 统一管理
 * 集中管理所有 API 请求
 */
import axios from 'axios'

// 创建 axios 实例
const apiClient = axios.create({
  // 开发环境使用代理，生产环境使用服务器地址
  baseURL: 'https://tk.beiniu.vip',
  // baseURL: 'http://192.168.188.15:5005',
  // baseURL: 'http://127.0.0.1:5000',
    // : (process.env.VUE_APP_API_BASE_URL || 'https://tk1.beiniu.vip'),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true  // 支持跨域携带 cookies
})

// 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    // 添加认证头
    const token = localStorage.getItem('tiktok_access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    console.log('API 请求:', config.method?.toUpperCase(), config.url)
    return config
  },
  (error) => {
    console.error('请求拦截器错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    console.log('API 响应:', response.status, response.config.url)
    return response
  },
  (error) => {
    console.error('API 响应错误:', error.response?.status, error.response?.message)
    
    // 处理认证错误
    if (error.response?.status === 401) {
      localStorage.removeItem('tiktok_access_token')
      localStorage.removeItem('tiktok_refresh_token')
      localStorage.removeItem('tiktok_user_info')
      // 可以在这里触发登录跳转
    }
    
    return Promise.reject(error)
  }
)

export default apiClient 